import PropTypes from 'prop-types'
import axios from 'axios'
import { MFA } from '../mfaWizard/MFASteps'

async function EnrollToByFactor ( userId, factor, phoneNumber ) {    
    const apiUrl = factor == MFA.FACTORS.EMAIL ? process.env.REACT_APP_MFA_ENROLL_TO_EMAIL : process.env.REACT_APP_MFA_ENROLL_TO_SMS
    try {
        const response = await axios.post( apiUrl, {
            userId: userId,
            ...( factor == MFA.FACTORS.SMS ? { phoneNumber } : { } )
        } )
        return response.data
    } catch ( e ) {
        throw Error( e )
    }
}
EnrollToByFactor.propTypes = {
    userId: PropTypes.string.isRequired,
    factor: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired
}

async function IssueChallenge ( userId, factorId ) {
    const apiUrl = process.env.REACT_APP_MFA_ISSUE_CHALLENGE
    try {
        const response = await axios.post( apiUrl, {
            userId: userId,
            factorId: factorId
        } )
        return response.data
    } catch ( e ) {
        throw Error( e )
    }
}
IssueChallenge.propTypes = {
    userId: PropTypes.string.isRequired,
    factorId: PropTypes.string.isRequired
}

async function VerifyMFAFactor ( userId, factorId, passCode ) {
    const apiUrl = process.env.REACT_APP_MFA_VERIFY_CODE
    return axios.post( apiUrl,  
        { 
            stateToken: userId,
            factorId:  factorId,
            passCode:  passCode
        } )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}

VerifyMFAFactor.propTypes = {
    userId: PropTypes.string.isRequired,
    factorId: PropTypes.string.isRequired,
    passCode: PropTypes.string.isRequired
}

async function ValidateChallengeCode ( userId, factorId, passCode, mfaRememberMe ) {
    const apiUrl = process.env.REACT_APP_MFA_VERIFY_CODE
    return axios.post( apiUrl,  
        { 
            userId: userId,
            factorId:  factorId,
            passCode:  passCode,
            mfaRememberMe: mfaRememberMe
        } )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}

ValidateChallengeCode.propTypes = {
    userId: PropTypes.string.isRequired,
    factorId: PropTypes.string.isRequired,
    passCode: PropTypes.string.isRequired,
    mfaRememberMe: PropTypes.bool.isRequired
}

async function ActivateFactor ( userId, factorId, passCode, mfaRememberMe  ) {
    const apiUrl = process.env.REACT_APP_MFA_ACTIVE_CODE
    return axios.post( apiUrl,  
        { 
            userId: userId,
            factorId:  factorId,
            passCode:  passCode,
            mfaRememberMe: mfaRememberMe
        } )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}

ActivateFactor.propTypes = {
    userId: PropTypes.string.isRequired,
    factorId: PropTypes.string.isRequired,
    passCode: PropTypes.string.isRequired,
    mfaRememberMe: PropTypes.bool.isRequired
}

async function GetUserFactors ( userId ) {    
    const apiUrl = `${ process.env.REACT_APP_MFA_FACTORS }${ userId }`
    return axios.get( apiUrl )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}
GetUserFactors.propTypes = {
    userId: PropTypes.string.isRequired
}

async function LogInAPI ( props ) {
    const { webId, password, rememberMe, returnUrl, userId } = props
    const apiMFAUrl = process.env.REACT_APP_MFA_LOG_IN

    return axios.post(
        apiMFAUrl,
        {
            WebId: webId,
            Password: password,
            UserId: userId,
            RememberID: rememberMe,
            ReturnUrl: returnUrl
        },
        { 
            withCredentials: true
        } )
        .then( response => {
            return response.data
        } )
        .catch( e => {
            throw Error( e )
        } )
}

LogInAPI.propTypes = {
    webId: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    rememberMe: PropTypes.bool.isRequired,
    returnUrl: PropTypes.string.isRequired,
    apiUrl: PropTypes.string.isRequired,
    userId: PropTypes.string
}
async function ResetFactor ( userId, factorId ) {    
    const apiUrl = process.env.REACT_APP_MFA_RESET_FACTOR
    return axios.post( apiUrl,  
        { 
            userId: userId,
            factorId:  factorId
        } )
        .then( response => {
            return response.status == 204
        } )
        .catch( e => {
            throw Error( e )
        } )
}
ResetFactor.propTypes = {
    userId: PropTypes.string.isRequired,
    factorId: PropTypes.string.isRequired
}
async function ResetAllFactors ( userId ) {    
    const apiUrl = process.env.REACT_APP_MFA_RESET_ALL_FACTORS
    return axios.post( apiUrl,  
        { 
            userId: userId
        } )
        .then( response => {
            return response.status == 200
        } )
        .catch( e => {
            throw Error( e )
        } )
}
ResetAllFactors.propTypes = {
    userId: PropTypes.string.isRequired
}

export const MFAService = { EnrollToByFactor, VerifyMFAFactor, ActivateFactor, GetUserFactors, LogInAPI, IssueChallenge, ValidateChallengeCode, ResetFactor, ResetAllFactors }